import React, { FunctionComponent } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { Route, useHistory, useRouteMatch } from "react-router"
import { iArtPiece } from "../../../definitions/ArtPieces"
import ArtPieceHeader from "../Header"
import ArtPieceOverview from "../inspector/Overview"
import ArtPieceUploads from "../inspector/Uploads"
import { post } from "../../../store/data/actions"
import { store } from "react-notifications-component"
import { notificationOptions } from "../../../api/Definitions"
import { withPackage } from "../../../components/withPackage/withPackage"
import ArtPieceSaleInfo from "../inspector/SaleInfo"
import ArtPiecePainting from "../inspector/Painting"
import ArtPieceDrawing from "../inspector/Drawing"
import ArtPieceSculpture from "../inspector/Sculpture"
import ArtPiecePrint from "../inspector/Print"
import ArtPiecePhotography from "../inspector/Photography"
import ArtPieceVideo from "../inspector/Video"
import ArtPieceStreetArt from "../inspector/StreetArt"
import ArtPieceAudio from "../inspector/Audio"

const CreateArtPiece: FunctionComponent = () => {
  const history = useHistory()
  const match = useRouteMatch()
  const methods = useForm({ shouldUnregister: false })

  const onSubmit = (data: iArtPiece) => {
    post<iArtPiece>({ link: "/v1/create-art-piece", data }).then((art) => {
      history.push("/art-pieces/" + art.shrUrl)
      store.addNotification({
        title: "Success!",
        message: "Art piece successfully created!",
        type: "success",
        ...notificationOptions,
      })
    })
  }

  const type = methods.watch("shrType")

  return (
    <FormProvider {...methods}>
      <ArtPieceHeader
        submitDeleteText="Delete"
        title="Create Art piece"
        submitText="Create"
        handleSubmit={() => {
          methods.handleSubmit((data) => {
            onSubmit(data as iArtPiece)
          })()
        }}
        artPieceType={type}
        type="create"
      />
      <div className="inspector">
        <form
          onSubmit={methods.handleSubmit((data) => {
            onSubmit(data as iArtPiece)
          })}
          className="inspector-form"
        >
          <Route exact path={match.path}>
            <ArtPieceOverview />
          </Route>
          <Route exact path={match.path + "/manage-files"}>
            <ArtPieceUploads />
          </Route>
          <Route exact path={match.path + "/sale-info"}>
            <ArtPieceSaleInfo />
          </Route>
          {type && (
            <>
              {type === "PAINTING" && (
                <Route exact path={match.path + "/painting"}>
                  <ArtPiecePainting />
                </Route>
              )}
              {type === "DRAWING" && (
                <Route exact path={match.path + "/drawing"}>
                  <ArtPieceDrawing />
                </Route>
              )}
              {type === "SCULPTURE" && (
                <Route exact path={match.path + "/sculpture"}>
                  <ArtPieceSculpture />
                </Route>
              )}
              {type === "PRINT" && (
                <Route exact path={match.path + "/print"}>
                  <ArtPiecePrint />
                </Route>
              )}
              {type === "PHOTOGRAPHY" && (
                <Route exact path={match.path + "/photography"}>
                  <ArtPiecePhotography />
                </Route>
              )}
              {type === "VIDEO" && (
                <Route exact path={match.path + "/video"}>
                  <ArtPieceVideo />
                </Route>
              )}
              {type === "STREETART" && (
                <Route exact path={match.path + "/street-art"}>
                  <ArtPieceStreetArt />
                </Route>
              )}
              {type === "AUDIO" && (
                <Route exact path={match.path + "/audio"}>
                  <ArtPieceAudio />
                </Route>
              )}
            </>
          )}
          <button className="d-none" type="submit">
            Submit
          </button>
        </form>
      </div>
    </FormProvider>
  )
}

export default withPackage(CreateArtPiece, "ArtPieces")
